import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import classnames from "classnames";
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import { useDrawer } from "../providers";
import styles from "../Drawer.module.scss";
export const DrawerContent = ({ className, children, ...restProps }) => {
    const drawerContentRef = useRef();
    const { isOpen, closeDrawer } = useDrawer();
    const onOutsideClick = () => {
        isOpen && closeDrawer();
    };
    useOutsideClick(drawerContentRef, onOutsideClick);
    return (_jsx("div", { className: classnames([
            styles.drawerContent,
            className,
            {
                [styles.isOpen]: isOpen,
            },
        ]), "data-testid": "drawer-content", ref: drawerContentRef, ...restProps, children: children }));
};
DrawerContent.displayName = "DrawerContent";
//# sourceMappingURL=DrawerContent.js.map